import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import UDTabs, { Tab } from 'modules/ud-ui/components/tabs';
import { defaultTab, TourneyEditFormPart } from './constants';
import { Championship } from 'modules/tourneys/domain/interfaces/Championship';
import UDText from '../../../../ud-ui/components/text';
import { useSelector } from 'react-redux';
import { championshipTeamsIsLoadedSelector } from '../../../store/championship/selectors';

type CreateEditFormParams = {
  tab: Tab;
  count?: number;
  isActive?: boolean;
};

const createEditFormTab = (params: CreateEditFormParams): Tab => {
  const { tab, count, isActive } = params;

  if (count !== undefined) {
    const badgeBgColor = isActive
      ? 'bgc-SurfaceWhite'
      : 'bgc-AccentNapplesYellow';
    const className = classNames([
      'color-SurfaceRaisinBlack50',
      badgeBgColor,
      'p-1',
      'br-4',
      'ml-2',
      'line-height-1',
      'caption-1',
    ]);

    return {
      hash: tab.hash,
      label: (
        <>
          {tab.label}{' '}
          <UDText type="subhead" className={className}>
            {count}
          </UDText>
        </>
      ),
    };
  }

  return tab;
};

type TourneyEditFormTabsProps = {
  tourney: Championship;
};

const TourneyEditFormTabs = ({ tourney }: TourneyEditFormTabsProps) => {
  const location = useLocation();
  const activeTab = (location.hash || '').split('/')[0];
  const isApplicationsLoaded = useSelector(championshipTeamsIsLoadedSelector);

  const tabs = useMemo(() => {
    return Object.values(TourneyEditFormPart).map((tab) =>
      createEditFormTab({
        tab: tab,
        // count: (tab.hash === TourneyEditFormPart.APPLICATIONS.hash && isApplicationsLoaded)
        //   ? tourney.applications.length
        //   : undefined,
        isActive: tab.hash === activeTab,
      })
    );
  }, [tourney, activeTab, isApplicationsLoaded]);

  return <UDTabs tabs={tabs} defaultTab={defaultTab} />;
};

export default TourneyEditFormTabs;
